import { render, staticRenderFns } from "./dropdown_contents_create_view.vue.js?vue&type=template&id=53545360&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dropdown_contents_create_view.vue?vue&type=template&id=53545360&vue3"
import script from "./dropdown_contents_create_view.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dropdown_contents_create_view.vue?vue&type=script&lang=js&vue3"
export * from "./dropdown_contents_create_view.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dropdown_contents_create_view.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports